const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.authentication', {
            abstract: true,
            onExit: [
                'LoginService', function (loginService) {
                    // If the state was navigated to as a result of a prompt for login,
                    // we need to reject the promise for the prompt when we exit the login panel.
                    // If the login is successful, the promise should already have been resolved and
                    // this will do nothing.
                    loginService.rejectPromptForLogin();
                },
            ],
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
            },
            data: {
                onAuthReturnToState: 'root',
            },
        })
        .state('shop.authentication.login', {
            url: '/securelogin?redirect',
            params: {
                toState: null,
                toStateParams: null,
                toStateOptions: { reload: false },
                customCallback: null,
            },
            onEnter: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                // When toState is not specified in the stateParams use
                // previous state, if available, for redirection.
                if (!$stateParams.toState && $rootScope.onAuthRedirectedState) {
                    $stateParams.toState = $rootScope.onAuthRedirectedState.name;
                    $stateParams.toStateParams = $rootScope.onAuthRedirectedStateParams;
                }
            }],
            resolve: {
                authenticationMethod: ['ShopperService', function (shopperService) {
                    return shopperService.getAuthenticationMethod().then(result => result.AuthenticationMethod);
                }],
            },
            views: {
                'center-panel': {
                    controller: [
                        '$scope', '$state', '$stateParams', '$timeout', 'authenticationMethod', function ($scope, $state, $stateParams, $timeout, authenticationMethod) {
                            this.authenticationMethod = authenticationMethod;

                            $scope.$on('login:success', () => {
                                if ($stateParams.customCallback) {
                                    $stateParams.customCallback();
                                } else {
                                    // Redirect with a page load in a timeout to make sure other 'login:success'
                                    // handlers also get to run
                                    $timeout(() => {
                                        // redirect query param will be injected to the user when the user is logged out from SSR pages.
                                        window.location.href = $stateParams.redirect || ($stateParams.toState
                                            ? $state.href($stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/'
                                            : '/');
                                    }, 0, false);
                                }
                            });
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-login-page authentication-method="$ctrl.authenticationMethod"></wow-login-page>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Woolworths Supermarket - Buy Groceries Online',
                    metaDescription: 'Woolworths Supermarket - Buy Groceries Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.authentication.signup', {
            url: '/signup?id&token',
            params: {
                toState: null,
                toStateParams: null,
                toStateOptions: { reload: false },
                customCallback: null,
            },
            views: {
                'center-panel': {
                    controller: [
                        '$scope', '$state', '$stateParams', '$timeout', function ($scope, $state, $stateParams, $timeout) {
                            $scope.$on('signup:success', () => {
                                if ($stateParams.customCallback) {
                                    $stateParams.customCallback();
                                } else {
                                    // Redirect with a page load in a timeout to make sure other 'signup:success'
                                    // handlers also get to run
                                    $timeout(() => {
                                        window.location.href = $stateParams.toState
                                            ? $state.href($stateParams.toState.name || $stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/'
                                            : '/';
                                    }, 0, false);
                                }
                            });
                        },
                    ],
                    template: '<wow-signup-page></wow-signup-page>',
                },
            },
        })
        // Reset password
        .state('shop.authentication.resetpassword', {
            url: '/resetpassword?passwordResetToken',
            views: {
                'center-panel': {
                    controller: [
                        '$stateParams', function ($stateParams) {
                            this.passwordResetToken = $stateParams.passwordResetToken;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-reset-password password-reset-token="{{::$ctrl.passwordResetToken}}"></wow-reset-password>',
                },
            },
        })
        // Forgot password
        .state('shop.authentication.forgotpassword', {
            url: '/forgotpassword',
            views: {
                'center-panel': {
                    template: '<wow-login-forgot-password></wow-login-forgot-password>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/authentication.js